
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

import HeroMockup from "@/components/landing/HeroMockup";

const DashboardMockup = () => (
    <div className="relative w-full flex justify-center items-start lg:p-6 animate-float -mb-24 lg:mb-0">
        <div
            className="origin-top"
            style={{
                transform: 'scale(var(--mockup-scale, 1))',
                width: 520,
                maxWidth: 520,
                overflow: 'visible',
            }}
        >
            <HeroMockup />
        </div>
        <style>{`
            :root { --mockup-scale: 1; }
            @media (max-width: 400px) { :root { --mockup-scale: 0.58; } }
            @media (min-width: 401px) and (max-width: 480px) { :root { --mockup-scale: 0.68; } }
            @media (min-width: 481px) and (max-width: 560px) { :root { --mockup-scale: 0.78; } }
            @media (min-width: 561px) and (max-width: 640px) { :root { --mockup-scale: 0.88; } }
            @media (min-width: 641px) and (max-width: 1023px) { :root { --mockup-scale: 0.95; } }
        `}</style>
    </div>
);

export const LandingHero = () => {
    return (
        <section className="relative pt-32 pb-0 lg:pt-48 lg:pb-16 bg-gradient-to-b from-white to-gray-50/50">
            {/* Background Gradient */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-primary/5 via-transparent to-transparent" />
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_var(--tw-gradient-stops))] from-accent/5 via-transparent to-transparent" />
            </div>

            <div className="container mx-auto px-4 grid lg:grid-cols-2 gap-12 items-center relative">
                <div className="space-y-8 text-center lg:text-left z-10">
                    <div className="space-y-4">
                        <h1 className="font-heading text-4xl lg:text-6xl font-bold tracking-tight text-gray-900 leading-[1.1]">
                            Run giveaways in <br className="hidden lg:block" />
                            <span className="text-primary relative inline-block">
                                minutes
                                <svg className="absolute w-full h-3 -bottom-1 left-0 text-accent/30 -z-10" viewBox="0 0 100 10" preserveAspectRatio="none">
                                    <path d="M0 5 Q 50 10 100 5 L 100 10 L 0 10 Z" fill="currentColor" />
                                </svg>
                            </span> — not hours.
                        </h1>
                        <p className="text-xl text-gray-600 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                            RaffleKit helps small businesses launch simple, powerful contests without complicated setup, surprise fees, or feature paywalls.
                        </p>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                        <Button asChild size="lg" variant="accent" className="h-14 px-8 rounded-full font-bold text-lg hover:-translate-y-0.5 transition-all">
                            <Link to="/admin?mode=signup">
                                Start Free — No Credit Card
                            </Link>
                        </Button>
                        <Button asChild variant="outline" size="lg" className="h-14 px-8 rounded-full bg-white">
                            <a href="#pricing">See Pricing</a>
                        </Button>
                    </div>

                    <div className="flex items-center justify-center lg:justify-start gap-2 text-sm text-gray-500">
                        <CheckCircle2 className="w-4 h-4 text-green-500" />
                        <span>1 active contest free forever</span>
                        <span className="w-1 h-1 rounded-full bg-gray-300" />
                        <span>Upgrade anytime</span>
                    </div>
                </div>

                <div className="relative pt-4 pb-0 lg:pt-0 perspective-1000 w-full overflow-hidden lg:overflow-visible">
                    <DashboardMockup />
                    {/* Decorative splashes */}
                    <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-gradient-to-tr from-primary/20 to-accent/20 rounded-full blur-3xl -z-10 opacity-30" />
                </div>
            </div>
        </section>
    );
};
